<template>
  <footer class="f_kelly-R">
  	<div class="container container-fix">
  	  <div class="subscibe"><input type="text" placeholder="Enter your email to receive our Newsletter and Exclusive Discount. " class="subs-input"> <input type="button" value="Submit" class="subs-btn"></div>
  	 <div class="clearfix"></div>
  	<ul class="row footer-menu">
  		<li class="col-md-2">
  			<h4>Watches</h4>
  			<ul>
  				<li><a href="#">All Watches</a></li>
  				<li><a href="#">Best Sale</a></li>
  				<li><a href="#">New Arrival</a></li>
  				<li><a href="#">Brands</a></li>
  			</ul>
  		</li>
  		<li class="col-md-2">
  			<h4>Auctions</h4>
  			<ul>
  				<li><a href="#">Open Lots</a></li>
  				<li><a href="#">Live Auction</a></li>
  			</ul>
  		</li>
  		<li class="col-md-2">
  			<h4>Services</h4>
  			<ul>
  				<li><a href="#">Maintenance</a></li>
  				<li><a href="#">Sell a Watch</a></li>
  				<li><a href="#">Trade a Watch</a></li>
  			</ul>
  		</li>
  		<li class="col-md-2">
  			<h4>Articles</h4>
  			<ul>
  				<li><a href="#">News</a></li>
  				<li><a href="#">Blog</a></li>
  			</ul>
  		</li>
  		<li class="col-md-2">
  			<h4>Company</h4>
  			<ul>
  				<li><a href="#">About Us</a></li>
  				<li><a href="#">Our Team</a></li>
  				<li><a href="#">Legal details</a></li>
  			</ul>
  		</li>
  		<li class="col-md-2">
  			<h4>Support</h4>
  			<ul>
  				<li><a href="#">FAQs</a></li>
  				<li><a href="#">Contact Us</a></li>
  				<li><a href="#">Phone: 22223333</a></li>
  			</ul>
  		</li>
  	</ul>

  	<div class="follow">
  		<h4>Follow Us</h4>
  		<ul class="follow-icons">
  			<li><a href="#" class="follow_icon1 icons">Facebook</a></li>
  			<li><a href="#" class="follow_icon2 icons">Instagram</a></li>
  			<li><a href="#" class="follow_icon3 icons">WhatsApp</a></li>
  			<li><a href="#" class="follow_icon4 icons">LinkedIn</a></li>
  			<li><a href="#" class="follow_icon5 icons">Twitter</a></li>
  			<li><a href="#" class="follow_icon6 icons">YouTube</a></li>
  		</ul>
  	</div>


  	<div class="copyright">
  		<span>&copy; {{year}} ViaWatch. All Rights Reserved</span>
  		<ul class="copyright-links">
  			<li><a href="#">Privacy Policy</a></li>
  			<li><a href="#">Terms &amp; Conditions</a></li>
  			<li><a href="#">Site Map</a></li>
  		</ul>

  		</div>

  	</div>


  </footer>
</template>

<script>
export default {
  // ©
  name: 'xh-footer',
  data() {
    return {
      year: new Date().getFullYear()
    }
  }
}
</script>

<style scoped>
  h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6 {
    color: #fff;
  }
  @media (max-width: 1200px) {
    .container-fix {
      max-width: 100%;
    }
    .copyright-links {
      top: inherit;
    }
  }
</style>



// WEBPACK FOOTER //
// src/layout/XhFooter.vue